export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {

      $('.open-popin').click(function(e){
          e.preventDefault();
          e.stopPropagation();
          $('body').addClass('popin-active');
          $('#popin-register').show();
      });

      $(document).click(function(event) {
          if( !$(event.target).closest('#popin-register .main-content').length && $('body').addClass('popin-active') ){
              $('body').removeClass('popin-active');
              $('#popin-register').hide();
          }
      });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js